import React from "react";
import { CardContainer, StyledCardLink, VideoTitle } from "../components";
import ReactPlayer from "react-player";

const VideoCard = ({ video }) => {
  return (
    <StyledCardLink to={video.id}>
      <CardContainer>
        <ReactPlayer
          url={`${video.url}`}
          width={"222px"}
          height={"222px"}
          light={!video.img ? true : video.img}
          playing={false}
        />
        <VideoTitle>{video.title}</VideoTitle>
      </CardContainer>
    </StyledCardLink>
  );
};

export default VideoCard;
